import { useCallback } from 'react';
import { getContext } from '@picsart/miniapps-sdk';

import { ALLOWED_LIMIT_FILES, IMAGE_MIME_TYPES } from 'pages/Batch/configs';

async function getFileFromUrl(url: string, name: string = '') {
  const response = await fetch(url);
  const data = await response.blob();

  let fileName = name;
  if (!fileName) {
    fileName = `BatchFile_${new Date().getTime().toString(36)}`;
  }

  return new File([data], fileName, { type: IMAGE_MIME_TYPES.WEBP });
}

const useMiniappHelpers = () => {
  const miniappUploader = useCallback(async (allowMultiple = true, maxCount = ALLOWED_LIMIT_FILES): Promise<File[]> => {
    const uploadedLayer = await getContext().handlers.openFileChooser({
      multiSelectEnabled: allowMultiple,
      allowedFormats: ['photo'],
      maxCount,
    });

    if (!uploadedLayer.images) {
      throw new Error("Couldn't get uploaded image");
    }
    const promises = uploadedLayer.images.map(async image => {
      const url = uploadedLayer.resources?.[image.getParams().settings.photo].location as string;
      return getFileFromUrl(url);
    });
    const promisedFiles = await Promise.all(promises);
    return promisedFiles;
  }, []);

  return {
    miniappUploader,
  };
};

export default useMiniappHelpers;
